export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST"
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS"
export const GET_USER_PROFILE_FAIL = "GET_USER_PROFILE_FAIL"

export const GET_USER_PROFILE_FOLLOWERS_REQUEST = "GET_USER_PROFILE_FOLLOWERS_REQUEST"
export const GET_USER_PROFILE_FOLLOWERS_SUCCESS = "GET_USER_PROFILE_FOLLOWERS_SUCCESS"
export const GET_USER_PROFILE_FOLLOWERS_FAIL = "GET_USER_PROFILE_FOLLOWERS_FAIL"